import React, { createContext, useContext, useState, useCallback } from 'react';

const WhatsAppMessageContext = createContext(null);

export const useWhatsAppMessage = () => {
  const context = useContext(WhatsAppMessageContext);
  if (!context) {
    throw new Error('useWhatsAppMessage must be used within WhatsAppMessageProvider');
  }
  return context;
};

export const WhatsAppMessageProvider = ({ children }) => {
  const [messageHandler, setMessageHandler] = useState(null);
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);

  const registerMessageHandler = useCallback((handler) => {
    setMessageHandler(() => handler);
  }, []);

  const unregisterMessageHandler = useCallback(() => {
    setMessageHandler(null);
  }, []);

  const handleNewMessage = useCallback((message) => {
    if (messageHandler) {
      messageHandler(message);
    }
  }, [messageHandler]);

  const incrementUnreadCount = useCallback((count = 1) => {
    setTotalUnreadCount((prev) => prev + count);
  }, []);

  const decrementUnreadCount = useCallback((count = 1) => {
    setTotalUnreadCount((prev) => Math.max(0, prev - count));
  }, []);

  const setUnreadCount = useCallback((count) => {
    setTotalUnreadCount(count);
  }, []);

  const resetUnreadCount = useCallback(() => {
    setTotalUnreadCount(0);
  }, []);

  return (
    <WhatsAppMessageContext.Provider
      value={{
        registerMessageHandler,
        unregisterMessageHandler,
        handleNewMessage,
        totalUnreadCount,
        incrementUnreadCount,
        decrementUnreadCount,
        setUnreadCount,
        resetUnreadCount,
      }}
    >
      {children}
    </WhatsAppMessageContext.Provider>
  );
};

